(function(){
  const KEY = 'homeMode'; // localStorage key: 'ecom' | 'food' | 'services'
  const container = document.getElementById('mode-toggle');
  if (!container) return;

  const buttons = container.querySelectorAll('button[data-mode]');
  const sections = {
    ecom:     document.querySelector('[id^="shopify-section-"][id$="home_ecom"]'),
    food:     document.querySelector('[id^="shopify-section-"][id$="home_food"]'),
    services: document.querySelector('[id^="shopify-section-"][id$="home_services"]')
  };

  function apply(mode){
    // hide all three, show selected
    Object.values(sections).forEach(el => { if (el) el.style.display = 'none'; });
    (sections[mode] || sections.ecom).style.display = 'block';

    // update buttons
    buttons.forEach(b => b.classList.toggle('is-active', b.dataset.mode === mode));

    // set body class for theme colors
    document.body.classList.remove('mode-ecom','mode-food','mode-services');
    document.body.classList.add(`mode-${mode}`);

    // persist
    try { localStorage.setItem(KEY, mode); } catch {}
  }

  // init from storage (default = ecom)
  const stored = (localStorage.getItem(KEY) || 'ecom');
  apply(stored);

  // clicks
  buttons.forEach(btn => btn.addEventListener('click', () => apply(btn.dataset.mode)));

  // OPTIONAL: global quickAdd for Food shelf “Add” buttons
  window.quickAdd = async function(variantId){
    const fd = new FormData(); fd.append('id', variantId); fd.append('quantity', 1);
    try {
      await fetch('/cart/add.js', { method:'POST', body:fd, headers:{'Accept':'application/json'}, credentials:'same-origin' });
      // use drawer vs toast based on your existing setting
      const behavior = (window.cartBehavior || 'drawer');
      const cart = await fetch('/cart.js', { credentials:'same-origin' }).then(r=>r.json());
      // header count update (from your drawer file helper)
      const el = document.getElementById('cart-count'); if (el) el.textContent = cart.item_count || 0;
      if (behavior === 'drawer') {
        // if you want to open the drawer, dispatch a custom event your drawer listens to
        document.dispatchEvent(new CustomEvent('open-cart-drawer'));
      } else if (window.showToast) {
        window.showToast('Added to cart');
      }
    } catch(e) { alert('Could not add to cart'); }
  };
})();
